export default __webpack_public_path__ + "static/media/jsrbrtable_Prt.163bc040.webp";